import React from 'react';

export type ContentLoaderSize = 'sm' | 'md' | 'lg';

interface ContentLoaderProps {
  message?: string;
  size?: ContentLoaderSize;
  /** panel: centered area; inline: compact row for tight spaces */
  variant?: 'panel' | 'inline';
  /** When variant is panel, wrap in a card container (default true) */
  withCard?: boolean;
  className?: string;
  minHeight?: string;
}

const messageSizeClass: Record<ContentLoaderSize, string> = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
};

const ContentLoader: React.FC<ContentLoaderProps> = ({
  message = 'Loading...',
  size = 'md',
  variant = 'panel',
  withCard = true,
  className = '',
  minHeight,
}) => {
  const messageClass = `${messageSizeClass[size]} font-medium text-text-muted-dark`;

  if (variant === 'inline') {
    return (
      <div
        className={`flex items-center ${className}`}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <p className={messageClass}>{message}</p>
      </div>
    );
  }

  const panelStyle = { minHeight: minHeight ?? '300px' };
  const content = (
    <div
      className={`flex flex-col items-center justify-center text-center ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <p className={messageClass}>{message}</p>
    </div>
  );

  if (!withCard) {
    return (
      <div className="flex w-full items-center justify-center" style={panelStyle}>
        {content}
      </div>
    );
  }

  return (
    <div className="card flex w-full items-center justify-center" style={panelStyle}>
      {content}
    </div>
  );
};

export default ContentLoader;
